export const production = {
  host: 'https://api.dashboard.srest.io',
  env: 'production',
  sentry: {
    enabled: true,
  },
  amplify: {
    region: 'ap-northeast-1',
    userPoolId: 'ap-northeast-1_Qos6veGlb',
    userPoolWebClientId: '5ei531q55dk4s786pf02s5o868',
  },
};
